var header = require("head");

var Loader = {
    queue: null,
    tl: null,
    isTouchDevice: function() {  return 'ontouchstart' in window || 'onmsgesturechange' in window; },
    loadApp: function () {
        head.ready(document, function() {
            head.load([
                "/lib/uint8clampedarray.js",
                "/assets/app.js",
                "/lib/mapboxgl/mapbox-gl.js",
                "/lib/scrollmagic/ScrollMagic.js",
                "/lib/scrollmagic/plugins/animation.gsap.js",
                "/lib/scrollmagic/plugins/debug.addIndicators.js",
                "/assets/app.css",
                "http://fast.fonts.net/cssapi/9866b4e8-cab1-4a30-9580-6e2512629b90.css"
            ], Loader.startApp);
        });
    },
    removeLoader:function(){
        document.body.setAttribute("class", document.body.getAttribute("class").split("hideloader").join(""));
        var preloader = document.getElementsByClassName("preloader")[0];

        if(preloader && preloader.parentNode){
            preloader.parentNode.removeChild(preloader);
        }
    },
    startApp: function(){
        var self = this;

        if(window.App == undefined){
            setTimeout(Loader.startApp, 500);
        } else {
            App.blastoff();

            document.body.setAttribute("class", document.body.getAttribute("class").split("loading").join("loaded") );
            setTimeout(function(){
                document.body.setAttribute("class", document.body.getAttribute("class").split("loaded").join("hideloader") );
            }, 700);

            setTimeout(function(){ Loader.removeLoader(); }, 1400);
        }

    }
};

module.exports = Loader;
Loader.loadApp();



//////////////////
// WEBPACK FOOTER
// ./loader.js
// module id = 313
// module chunks = 2